module.exports = __webpack_public_path__ + "img/orange.bc18e626.png";